"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PageInfo_1 = __importDefault(require("../entity/PageInfo"));
class PageInfoStub extends PageInfo_1.default {
    constructor({ endCursor = 'abc', hasNextPage = true, hasPreviousPage = true, startCursor = 'xyz', } = {}) {
        super({ endCursor, hasNextPage, hasPreviousPage, startCursor });
    }
}
exports.default = PageInfoStub;
